import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { propertyCardFlexAreaStyles } from './styles/property-card-flex-area.styles';
import type { PropertyCardFlexAreaPropsInterface } from './types/property-card-flex-area.types';

/**
 * A container for custom content that appears after the data areas of a `PropertyCard`.
 *
 * @since 8.63.0
 */
export const PropertyCardFlexArea = forwardRef<HTMLDivElement, PropertyCardFlexAreaPropsInterface>(
  (props: PropertyCardFlexAreaPropsInterface, forwardedRef) => {
    const { asChild = false, children, className, css: cssProp, ...rest } = props;

    const styles = css(propertyCardFlexAreaStyles, cssProp);

    const Component = asChild ? Slot : 'div';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="PropertyCard.FlexArea"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

PropertyCardFlexArea.displayName = 'PropertyCard.FlexArea';
